import { EActionTypes, ILoanDto, IPromoLabel } from '@r1-frontend/api-domru/widgets/v2/auth/equipments/dto/ResponseDto';

import { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult';

export interface IKebabElement {
    value: string,
    label: string,
    typeAction?: EActionTypes,
    backgroundColor?: 'black'|'red',
    url?: string,
}

export interface IPrice {
    fullValue: string,
    info: string,
    /** @deprecated Форматирование цен должно быть на фронте. */
    unit: string,
}

export interface IRouterDevices {
    ip?: string,
    name: string,
    generation: string,
}

export interface IBaseScreenData {
    isError: boolean,
    title?: string,
    dataReceived: boolean,
}

export interface IInfoPayment {
    duration: number,
    dateFrom: string,
    paySum: number,
    leasingSum: number,
}

export type TDescriptionLink = { text?: string, func?: () => void, href?: string }

export interface IScreen {
    default: { active: boolean, data: IBaseScreenData },
}

export interface IWidget {
    productId: number,
    deviceId: number,
    globalId: number,
    materialsEnsId: number,
    widgetId: number,
    equipTypeId: number,
    title: string,
    type: string,
    screens: IScreen,
    screenIsLoading: boolean,
    image: string,
    imageBackground: string,
    description: string,
    subTitle: string,
    price: IPrice,
    activityId: number,
    leasingSum: number,
    label: string[],
    kebabItems: IKebabElement[],
    button?: {
        text?: string,
        bType?: string,
        typeAction?: EActionTypes,
        backgroundColor?: 'black' | 'red',
        url?: string,
    },
    infoPayment: IInfoPayment,
    promoLabel?: IPromoLabel,
    loan?: ILoanDto,
}

export interface TScreensRouter {
    default: { active: boolean, data: IBaseScreenData },
}

export interface IRouterWidget extends Omit<IWidget, 'screens'> {
    screens: {
        default: { active: boolean, data: IBaseScreenData },
    },
}

export const enum EPopupTypes {
    INIT = 'init',
    ACTION = 'action',
    REQUEST = 'request',
    RESULT = 'result',
    INFO = 'info',
    LOAN_INFO = 'loan_info',
}

interface IPopup {
    isOpen: boolean,
    title: string,
    text: JSX.Element | string,
    popupType: EPopupTypes,
}

export interface IInitPopup extends IPopup {
    popupType: EPopupTypes.INIT,
}

export interface IInfoPopup extends IPopup {
    popupType: EPopupTypes.INFO,
    btnText?: string,
    onClickBtn: () => void,
}

interface ILoanInfoPopup extends IPopup {
    popupType: EPopupTypes.LOAN_INFO,
    loanData: ILoanDto,
    onClickBtn: () => void,
}

export interface IActionPopup extends IPopup {
    btnText: string,
    bHref?: string,
    onClickBtn: () => void,
    popupType: EPopupTypes.ACTION,
}

export interface IRequestPopup extends IPopup {
    btnText: string,
    onClickBtn: (fio: string, phone: string) => void,
    popupType: EPopupTypes.REQUEST,
}

export interface IResultPopup extends IPopup {
    status: EResultPopupStatus,
    popupType: EPopupTypes.RESULT,
}

export type TPopup =
    Omit<IInitPopup, 'isOpen'> |
    Omit<IActionPopup, 'isOpen'> |
    Omit<IRequestPopup, 'isOpen'> |
    Omit<IResultPopup, 'isOpen'> |
    Omit<IInfoPopup, 'isOpen'> |
    Omit<ILoanInfoPopup, 'isOpen'>;

export type TWidgetsData = {
    connectionItems: Record<number, IWidget | IRouterWidget>,
    connectedItems: Record<number, IWidget | IRouterWidget>,
    loading: boolean,
    notify: { type: 'info' | 'success' | 'error', message: string, timeStamp: number },
    initialized: boolean,
    popupData: IInitPopup | IActionPopup | IRequestPopup | IResultPopup | IInfoPopup | ILoanInfoPopup,
};

export const initPopup: IInitPopup = {
    isOpen: false,
    title: '',
    text: '',
    popupType: EPopupTypes.INIT,
};

export const initialState: TWidgetsData = {
    connectionItems: {},
    connectedItems: {},
    notify: {
        type: 'info',
        message: '',
        timeStamp: 0,
    },
    loading: false,
    initialized: false,
    popupData: initPopup,
};
